/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".trigger-button[_ngcontent-%COMP%]{color:var(--be-secondary-text)}"];
export { styles as styles };
